import { render } from "./repository.vue?vue&type=template&id=72259ec4&scoped=true"
import script from "./repository.vue?vue&type=script&lang=js"
export * from "./repository.vue?vue&type=script&lang=js"

import "./repository.vue?vue&type=style&index=0&id=72259ec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72259ec4"]])

export default __exports__